import { useEffect, useState } from 'react';
import OrderApi from '../../Api/OrderApi';
import { Order } from '../../Models/Order';
import Loader from '../Common/Loader';
import { formatNumbers } from '../../Utils';
import { Button } from 'flowbite-react';
import { useAppSelector } from '../../Reducers/store';
import { FileTypeEnums } from '../../Models/FileType';
import blankImage from '../../Assets/NoPhoto.jpg';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function OrderReview() {
  const navigate = useNavigate();
  const { userModel } = useAppSelector((state) => state.user);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [loading, setIsLoading] = useState<boolean>();
  const [orderData, setOrderData] = useState<Order>({
    id: 0,
    businessName: null,
    contactName: null,
    contactPhone: null,
    contactEmail: null,
    notes: null,
    dateCreated: null,
    orderStatusId: null,
    userId: null,
    billingAddressId: null,
    shippingAddressId: null,
    dateSubmitted: null,
    ponumber: null,
    clientId: null,
    shippingMethodId: 15,

    client: null,
    orderItems: [],
    billingAddress: null,
    shippingAddress: null,
    user: null,
  });

  const getOrder = () => {
    setIsLoading(true);
    const openOrderId =
      localStorage.getItem('openOrderId') &&
      Number(localStorage.getItem('openOrderId')) >= 0
        ? Number(localStorage.getItem('openOrderId'))
        : 0;
    OrderApi.getOrder(openOrderId)
      .then((res) => {
        if (res.data.id > 0) {
          setOrderData(res.data);
          localStorage.setItem('openOrderId', res.data.id.toString());
        } else {
          //navigate away
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getOrder();
  }, []);

  const handleEstimateClick = () => {
    setButtonDisabled(true);
    setIsLoading(true);
    OrderApi.sendToRimss(orderData.id)
      .then((res) => {
        setButtonDisabled(false);
        if (res.data) {
          navigate(`/orders/confirm`);
        } else {
          toast.error('Error submitting estimate');
          setButtonDisabled(false);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setButtonDisabled(false);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className='w-full mt-4'>
        <div className='relative'>
          {loading && <Loader />}
          <div className='container mx-auto p-2'>
            <div className='mb-2 border-b-2 flex justify-between'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                Order Review:
              </h1>
              {orderData && (
                <div className='flex gap-3'>
                  <div className='flex gap-3 font-bold text-2xl items-end'>
                    <div>Total: </div>
                    <div>
                      $
                      {formatNumbers(
                        orderData.orderItems?.reduce(
                          (acc, item) =>
                            acc + item.quantity * (item.equipment?.price ?? 0),
                          0
                        )
                      )}
                    </div>
                  </div>
                  <div>
                    <Button
                      type='button'
                      onClick={handleEstimateClick}
                      className='buttonMain'
                      disabled={buttonDisabled}
                    >
                      Submit Order Estimate
                    </Button>
                  </div>
                </div>
              )}
            </div>
            <div className='h-[calc(100vh-142px)] md:h-[calc(100vh-210px)] overflow-y-auto'>
              <div className='w-full mb-2 flex justify-between'>
                <div className='flex flex-col px-0 text-md lg:px-5 md:text-lg lg:text-xl'>
                  <div className='flex'>
                    <div className='font-bold content-center'>Deliver to:</div>
                  </div>
                  <div className='font-bold content-center'>
                    {orderData.contactName}
                  </div>
                  <div className='font-bold content-center'>
                    {orderData.shippingAddress?.address1}{' '}
                  </div>
                  <div className='font-bold content-center'>
                    {orderData.shippingAddress?.city}
                    {', '}
                    {orderData.shippingAddress?.state?.name}{' '}
                    {orderData.shippingAddress?.zip}
                  </div>
                </div>
                <div className=''>
                  <Link
                    to={'/orders/checkout'}
                    className='text-blue-600 rounded-md text-md hover:bg-gray-100 px-5'
                    // onClick={() => saveForLater(info.row.original.equipment!)}
                  >
                    Edit
                  </Link>
                </div>
              </div>
              <hr className='my-5'></hr>
              <div className='mb-2 flex justify-between'>
                <h1 className='text-gray-900 font-bold text-2xl md:text-4xl'>
                  Cart:
                </h1>
              </div>
              <div className='w-full mb-2 flex justify-between'>
                <div className='flex flex-col px-0 text-md lg:px-5 md:text-lg lg:text-xl items-start gap-2'>
                  {orderData?.orderItems?.map((item) => (
                    <div key={item.id} className='flex justify-center'>
                      <img
                        key={item.id}
                        src={
                          item.equipment?.files &&
                          item.equipment?.files?.filter(
                            (x) => x.fileTypeId === FileTypeEnums.Photo
                          ).length > 0
                            ? item.equipment?.files.filter(
                                (x) => x.fileTypeId === FileTypeEnums.Photo
                              )[0].fileUrl
                            : blankImage
                        }
                        alt={item.equipment?.number + '-image'}
                        className='w-[150px] object-contain m-auto'
                      />
                      <div className='ml-2 content-center'>
                        <div>
                          Manufacturer: {item.equipment?.manufacturer?.name}
                        </div>
                        <div>Part #: {item.equipment?.number}</div>
                        <div>Quantity: {item.quantity}</div>
                        <div>
                          Price Estimate: $
                          {formatNumbers(
                            (item.equipment?.price ?? 1) * item.quantity
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className=''>
                  <Link
                    to={'/orders/view'}
                    className='text-blue-600 rounded-md text-md hover:bg-gray-100 px-5'
                    // onClick={() => saveForLater(info.row.original.equipment!)}
                  >
                    Edit
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
